import { render, staticRenderFns } from "./moveLocation.vue?vue&type=template&id=0cc22396&scoped=true&"
import script from "./moveLocation.vue?vue&type=script&lang=js&"
export * from "./moveLocation.vue?vue&type=script&lang=js&"
import style0 from "./moveLocation.vue?vue&type=style&index=0&id=0cc22396&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc22396",
  null
  
)

export default component.exports